module.exports = __webpack_public_path__ + "img/tron (76).ac6d203b.jpg";